module.exports = __webpack_public_path__ + "25221cf3b8b630751a03f3e3fcbb9651.MP3";